import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, organisationStructureSchema } from '../lib/schemas';

export interface OrganisationStructure {
  id: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  department_no?: string | null;
  department_name?: string | null;
  team_no?: string | null;
  team_name?: string | null;
  employee_no?: string | null;
  employee_name?: string | null;
  employee_email?: string | null;
  role?: string | null;
  special_role?: string | null;
  type?: string | null;
  department_email?: string | null;
  team_email?: string | null;
  department_pk?: string | null;
  team_pk?: string | null;
  start_date?: string | null;
  end_date?: string | null;
}

export type OrganisationStructureInput = Omit<
  OrganisationStructure,
  'id' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'
>;

export const organisationStructureService = {
  async getAll(): Promise<OrganisationStructure[]> {
    const result = await apiClient.get(apiUrl.organisationStructure(), {
      validate: envelopeSchema('organisation_structure', z.array(organisationStructureSchema)),
      deduplicate: true,
      context: 'getOrganisationStructure',
    });
    return result.organisation_structure;
  },

  async create(row: OrganisationStructureInput): Promise<OrganisationStructure> {
    const result = await apiClient.post(apiUrl.organisationStructure(), row, {
      validate: envelopeSchema('organisation_structure', organisationStructureSchema),
      context: 'createOrganisationStructure',
    });
    return result.organisation_structure;
  },

  async update(id: string, row: OrganisationStructureInput): Promise<OrganisationStructure> {
    const result = await apiClient.put(apiUrl.organisationStructure(id), row, {
      validate: envelopeSchema('organisation_structure', organisationStructureSchema),
      context: 'updateOrganisationStructure',
    });
    return result.organisation_structure;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(apiUrl.organisationStructure(id), {
      context: 'deleteOrganisationStructure',
    });
  },
};
